import { render, staticRenderFns } from "./ReferralInvite.vue?vue&type=template&id=7754d52e"
import script from "./ReferralInvite.vue?vue&type=script&lang=js"
export * from "./ReferralInvite.vue?vue&type=script&lang=js"
import style0 from "./ReferralInvite.vue?vue&type=style&index=0&id=7754d52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports